module.exports = __webpack_public_path__ + "static/media/hw_ni_22.588a66ac.flv";